<template>
  <ProfileOptInForm
    :is-sending="isSending"
    :success="success"
    :has-error="hasError"
    :error-message="errorMessage"
    v-bind="$props"
    @subscribe="handleSubscribe"
    @hide-error="hideError"
    @click="$emit('click', $event)"
    @event="$emit('event', $event)"
  />
</template>

<script>
import {
  computed,
  ref,
  toRefs,
  useContext,
  useStore,
} from '@nuxtjs/composition-api';
import { ProfileOptInForm } from '@campsite-bio/component-lib';
import axios from 'axios';

export default {
  components: {
    ProfileOptInForm,
  },

  props: {
    link: {
      type: Object,
      required: true,
    },

    enableUtmParameters: {
      type: Boolean,
      default: false,
    },

    utmMedium: String,
    utmSource: String,
    imageSize: String,
    imageStyle: String,
    btnSize: String,
    highlight: String,
    variant: String,
  },

  setup(props, { emit }) {
    const { link } = toRefs(props);
    const isSending = ref(false);
    const success = ref(false);
    const hasError = ref(false);
    const errorMessage = ref('');
    const { $config } = useContext();

    async function handleSubscribe(formData) {
      isSending.value = true;

      try {
        const { data } = await axios.request({
          method: 'post',
          url: `${$config.apiBaseUrl}/public/links/${props.link._id.$oid}/subscribe-email`,
          data: formData,
          responseType: 'json',
        });

        if (data.errors && !data.errors.length) {
          success.value = true;
          // Track successful form submit
          emit('event', `${link.value.email_options.type}-opt-in`);
        } else {
          let error;
          if (data.errors && typeof data.errors[0] === 'object')
            error = data.errors[0].error;
          else if (data.errors && typeof data.errors[0] === 'string')
            error = data.errors[0];

          hasError.value = true;
          if (error) errorMessage.value = error;
        }
      } catch (e) {
        console.error(e);
        if (e.response && e.response.data && e.response.data.errors) {
          errorMessage.value = e.response.data.errors[0];
        }
        hasError.value = true;
      }

      isSending.value = false;
    }

    function hideError() {
      hasError.value = false;
    }

    return {
      id: link.value._id.$oid,
      handleSubscribe,
      hideError,
      isSending,
      success,
      hasError,
      errorMessage,
    };
  },
};
</script>

<style lang="scss" scoped></style>
